import { render } from "./client.configuration.vue?vue&type=template&id=c9f3eae8"
import script from "./client.configuration.vue?vue&type=script&lang=js"
export * from "./client.configuration.vue?vue&type=script&lang=js"

import "./client.configuration.vue?vue&type=style&index=0&id=c9f3eae8&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__